import React, { useRef, useState, useEffect } from 'react';
import { gql, useQuery, useMutation, useLazyQuery } from '@apollo/client';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import Snackbar from '@material-ui/core/Snackbar';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import DeleteIcon from '@material-ui/icons/Delete';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import MuiAlert from '@material-ui/lab/Alert';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import '../DragDrop.css';
import ButtonHeader from '../components/ButtonHeader.jsx';

const GET_CARDHOLDERSFIELDS = gql`
  query cardholderFieldConfig {
    cardholderFieldConfig {
      fieldRows {
        weight
        fields {
          id
          label
          weight
          type
          required
          selectedMapField
          mapOptions {
            id
            data
          }
        }
      }
    }
  }
`;

const GET_AVAILABLEFIELDS = gql`
  query availableCardholderFields {
    availableCardholderFields {
      cardholderFields {
        id
        label
        type
      }
      customFields {
        id
        type
        fields
      }
    }
  }
`;

const UPDATE_CARDHOLDERFIELDS = gql`
  mutation updateCardholderFieldConfig($input: CardholderFieldConfigInput!) {
    updateCardholderFieldConfig(input: $input) {
      fieldRows {
        weight
        fields {
          id
          label
          weight
          type
          required
          selectedMapField
        }
      }
    }
  }
`;

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const defaultFields = [
  {
    id: '',
    label: '',
    weight: '',
    type: '',
    required: '',
  },
];

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '100%',
  },
  grid: {
    padding: 20,
    alignContent: 'center',
    margin: 'auto',
  },
  // TODO: 'gridcontainer' is referenced but not defined
  form: {
    textAlign: 'center',
    padding: 20,
  },
  textfield: {
    right: '20px',
    bottom: '8px',
  },
  dragdrop: {
    margin: 'auto',
  },
  trashcan: {
    position: 'relative',
  },
  buttonList: {
    display: 'flex',
    marginTop: '18px',
    justifyContent: 'space-around',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
  buttonListtwo: {
    display: 'flex',
    marginTop: '18px',
    marginRight: '-130px',
    marginTop: '0px', // TODO: Remove duplicate definition
    justifyContent: 'space-around',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
  checkbox: {
    marginTop: '38px',
    marginLeft: '46px',
    display: 'flex',
    marginTop: '18px', // TODO: Remove duplicate definition
    justifyContent: 'space-around',
  },
  textBoxcombo: {
    margin: theme.spacing(1),
    maxWidth: '98%',
    [`& fieldset`]: {
      borderRadius: 0,
    },
  },
}));

const defaultFieldsValues = {
  fieldRows: [
    {
      weight: 1,
      fields: [
        {
          id: 'firstName',
          label: 'First Name',
          weight: 1,
          type: 'string',
          required: true,
        },
      ],
    },
    {
      weight: 2,
      fields: [
        {
          id: 'lastName',
          label: 'Last Name',
          weight: 1,
          type: 'string',
          required: true,
        },
      ],
    },
    {
      weight: 3,
      fields: [
        {
          id: 'employeeNumber',
          label: 'Employee Number',
          weight: 1,
          type: 'integer',
          required: false,
        },
      ],
    },
    {
      weight: 4,
      fields: [
        {
          id: 'title',
          label: 'Title',
          weight: 1,
          type: 'string',
          required: false,
        },
      ],
    },
    {
      weight: 5,
      fields: [
        {
          id: 'office',
          label: 'Office Location',
          weight: 1,
          type: 'string',
          required: false,
        },
      ],
    },
  ],
};

const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

const CardholderFields = () => {
  const classes = useStyles();
  const [fieldType, setFieldType] = useState('textField');
  const [savebtn, setSaveBtn] = useState(false);
  const [subType, setSubType] = useState();
  const [fieldName, setFieldName] = useState();
  const [defaultValue, setDefaultValue] = useState();
  // const [databaseField, setDataBaseField] = useState();
  const [checked, setChecked] = useState(true);
  // const [panel, setPanel] = useState(false);
  const [checkedReq, setCheckedReq] = useState(true);
  const [fields, updateFields] = useState([]);
  const subComponet = useRef(null);
  const customComponent = useRef(null);
  const [openSnack, setOpenSnack] = useState(false);
  const [defaultOpen, setDefaultOpen] = useState(false);
  const [inputOfSomeKind, setInputOfSomeKind] = useState(null);
  const [subOptions, setSubOptions] = useState(defaultFields);
  const [isFieldsUpdated, setIsFieldsUpdated] = useState(false);
  const [customField, setCustomField] = useState(subType);
  const [fieldenabled, setFieldEnabled] = useState(false);
  const [FieldsList, setFieldList] = useState([]);

  let options;
  let fieldoptions;
  let CustomeFields;
  const matches = useMediaQuery('(max-width:1024px)');

  const queryCompleted = (data) => {
    let rawFields = data.cardholderFieldConfig.fieldRows.map((field) => {
      return {
        weight: field.weight,
        fields: field.fields,
      };
    });

    let thisprop = {};
    const list = [];

    let subFields = data.cardholderFieldConfig.fieldRows.map((field) => {
      thisprop = {
        id: field.id,
        label: field.label,
        type: field.type,
        mapOptions: field.mapOptions,
      };
      for (let i = 0; i < field.fields.length; i += 1) {
        list.push({
          id: field.fields[i].id,
          label: field.fields[i].label,
          type: field.fields[i].type,
          mapOptions: field.fields[i].mapOptions,
        });
      }
      return thisprop;
    });

    let FieldData = data.cardholderFieldConfig.fieldRows.filter((field) => field.weight);

    let length = 0;
    const prop = [];
    for (let property in FieldData) {
      if (data.cardholderFieldConfig.fieldRows.hasOwnProperty(property)) {
        length += 1;
      }
    }

    for (let j = 0; j < length; j += 1) {
      let rlength = 0;

      for (let rproperty in FieldData[j]) {
        if (FieldData[j].hasOwnProperty(rproperty)) {
          rlength += 1;
        }
      }

      for (let i = 0; i < rlength - 1; i += 1) {
        if (FieldData[j].fields[i]) {
          prop.push({
            id: FieldData[j].fields[i].id,
            label: FieldData[j].fields[i].label,
            weight: FieldData[j].fields[i].weight,
            type: FieldData[j].fields[i].type,
            required: FieldData[j].fields[i].required,
          });
        }
      }
    }

    updateFields(prop);
    getSubFields();
  };

  const queryConfigCompleted = (data) => {
    const updateNewItems = data.cardholderFieldConfig.fieldRows.reduce((items, nextItem) => {
      const temp = JSON.parse(JSON.stringify(nextItem.fields[0]));
      delete temp.__typename;
      return [...items, temp];
    }, []);
    updateFields(updateNewItems);
    getSubFields();
    setIsFieldsUpdated(true);
  };

  const combineArrays = async (subOptions, customFields) => {
    const array = [...subOptions, ...customFields];
    const uniqueArray = array.filter((v, i, a) => a.findIndex((t) => t.label === v.label) === i);
    setSubType(uniqueArray[0].label);
    setSubOptions(uniqueArray);
  };

  const queryCompletedSubFields = async (data) => {
    const subFields = data.availableCardholderFields.cardholderFields.map((field) => {
      return {
        id: field.id,
        label: field.label,
        type: field.type,
      };
    });
    const list = [];
    const custom = data.availableCardholderFields.customFields.map((field) => {
      const prop = {
        id: field.id,
        label: field.id,
        type: field.type,
      };
      if (field.fields) {
        for (let i = 0; i < field.fields.length; i += 1) {
          list.push({ id: field.id, label: field.fields[i], type: field.type });
        }
      }
      setFieldList(list);
      return prop;
    });
    combineArrays(subFields, custom);
  };

  const queryError = ({ graphQLErrors, networkError }) => {
    console.log(graphQLErrors);
    console.log(networkError);
  };

  const { data, loading, error, refetch } = useQuery(GET_CARDHOLDERSFIELDS, {
    notifyOnNetworkStatusChange: true,
    onCompleted: queryConfigCompleted,
    onError: queryError,
    fetchPolicy: 'no-cache',
  });

  const [getSubFields] = useLazyQuery(GET_AVAILABLEFIELDS, {
    notifyOnNetworkStatusChange: true,
    onCompleted: queryCompletedSubFields,
    onError: queryError,
  });

  const [updateCardholderFields] = useMutation(UPDATE_CARDHOLDERFIELDS, {
    variables: { input: inputOfSomeKind },
    onError: queryError,
  });

  const handleChangeReq = (event) => {
    setCheckedReq(!checkedReq);
  };
  const handleChange = (event) => {
    setChecked(!checked);
  };
  const handleType = (event) => {
    fieldoptions = FieldsList.filter((field) => field.id.includes(event.target.value));
    if (fieldoptions.length > 0) {
      setCustomField(fieldoptions[0].label);
    }
    setSubType(event.target.value);
  };

  const handleCustomField = (e) => {
    setCustomField(e.target.value);
  };

  const handleFieldType = (event) => {
    setFieldType(event.target.value);
    switch (event.target.value) {
      case 'textField':
        options = subOptions.filter((field) => field.type.includes('string'));
        setSubType(options[0].label);
        setFieldEnabled(false);
        setCustomField(null);
        break;
      case 'numField':
        options = subOptions.filter((field) => field.type.includes('integer'));
        setSubType(options[0].label);
        setFieldEnabled(false);
        setCustomField(null);
        break;

      case 'dateField':
        // TODO: add uncomment line below once date fields are added
        // options = subOptions.filter((field) => field.type.includes('date'));
        // Then remove line below
        options = subOptions.filter((field) => field.type.includes('string'));
        setFieldEnabled(false);
        setCustomField(null);
        break;
      case 'custom':
        options = subOptions.filter((field) => field.type.includes('mapping'));
        setSubType(options[0].label);
        fieldoptions = FieldsList.filter((field) => field.id.includes(options[0].id));
        setFieldEnabled(true);
        setCustomField(fieldoptions[0].label);
        break;
      default:
        options = subOptions.filter((field) => field.type.includes('string'));
        setSubType(options[0].label);
        setFieldEnabled(false);
        setCustomField(null);
        break;
    }
  };

  const handleAdd = (event) => {
    if (customField) {
      const items = Array.from(fields);
      const index = items.findIndex((item) => item.label === customField);
      if (index === -1) {
        items.splice(
          items.length,
          0,
          FieldsList[FieldsList.findIndex((field) => field.label === customField)]
        );
      } else {
        const [reorderedItem] = items.splice(index, 1);
        items.splice(items.length, 0, reorderedItem);
      }

      updateFields(items);
      setSaveBtn(true);
    } else {
      if (!subType) {
        setSubType(subOptions[0].label);
      }
      const items = Array.from(fields);
      const index = items.findIndex((item) => item.label === subType);
      if (index === -1) {
        items.splice(
          items.length,
          0,
          subOptions[subOptions.findIndex((field) => field.label === subType)]
        );
      } else {
        const [reorderedItem] = items.splice(index, 1);
        items.splice(items.length, 0, reorderedItem);
      }
      updateFields(items);
      setSaveBtn(true);
    }
    // TODO: Add Custom Field to List
    // // Add data to list
    // let length = 0;
    // const prop = [];
    // for (let property in data.cardholderFieldConfig.fieldRows) {
    //   if (data.cardholderFieldConfig.fieldRows.hasOwnProperty(property)) {
    //     length += 1;
    //   }
    // }
    // for (let j = 0; j < length; j += 1) {
    //   let rlength = 0;
    //   for (let rproperty in data.cardholderFieldConfig.fieldRows[j]) {
    //     if (data.cardholderFieldConfig.fieldRows[j].hasOwnProperty(rproperty)) {
    //       rlength += 1;
    //     }
    //   }
    //   for (let i = 0; i < rlength - 1; i += 1) {
    //     if (data.cardholderFieldConfig.fieldRows[j].fields[i]) {
    //       prop.push({
    //         id: data.cardholderFieldConfig.fieldRows[j].fields[i].id,
    //         label: data.cardholderFieldConfig.fieldRows[j].fields[i].label,
    //       });
    //     }
    //   }
    // }
    // prop.push({ id: databaseField, label: fieldName });
    // updateFields(prop);
    // setSaveBtn(true);
  };
  const handleSave = async (event) => {
    const prop = [];
    const newFields = [...fields];
    for (let i = 0; i < newFields.length; i += 1) {
      if (newFields[i]) {
        if (!newFields[i].required) {
          newFields[i].required = false;
        }
        if (!newFields[i].weight) {
          newFields[i].weight = 1;
        }
        prop.push({
          weight: i + 1,
          fields: [
            {
              id: newFields[i].id,
              label: newFields[i].label,
              weight: newFields[i].weight,
              type: newFields[i].type,
              required: newFields[i].required,
              selectedMapField: newFields[i].label,
            },
          ],
        });
      }
    }
    CustomeFields = { fieldRows: prop };
    setInputOfSomeKind(CustomeFields);
    setOpenSnack(true);
  };

  const restoreDefault = async () => {
    setInputOfSomeKind(defaultFieldsValues);
    setDefaultOpen(true);
  };

  const refetchRelist = async () => {
    refetch();
  };

  const handleUpdate = async () => {
    updateCardholderFields();
  };

  function handleOnDragEnd(result) {
    if (!result.destination) {
      return;
    }
    const items = Array.from(fields);

    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    updateFields(items);
  }

  // TODO: Implement Form Change for Custom Fields
  const formChange = (event) => {
    if (!event.target.value.includes('newField')) {
      // setSaveBtn(true);
    }
    if (event.target.value.includes('newField')) {
      // setSaveBtn(false);
    }
    if (event.target.value.includes('panel')) {
      // setPanel(true);
    } else {
      // setPanel(false);
    }
  };

  const resetList = (event) => {
    queryConfigCompleted(data);
    setSaveBtn(false);
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
    setDefaultOpen(false);
  };
  function FieldFind(item, id) {
    return item === id;
  }
  const handleDeleteField = async (event, field) => {
    const items = Array.from(fields);
    const index =
      field.type === 'mapping'
        ? items.map((e) => e.selectedMapField).indexOf(field.selectedMapField)
        : items.map((e) => e.id).indexOf(field.id);
    items.splice(index, 1);
    updateFields(items);
  };

  const getWidth = () =>
    window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  const getHieght = () =>
    window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  let [width, setWidth] = useState(getWidth());
  let [height, setHeight] = useState(getHieght());

  useEffect(() => {
    const resizeListener = () => {
      // change width from the state object
      setWidth(getWidth());
      setHeight(getHieght());
    };
    // set resize listener
    window.addEventListener('resize', resizeListener);
    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener('resize', resizeListener);
    };
  }, []);

  return (
    <>
      <ButtonHeader title="Custom Record Fields" />
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        <Link color="inherit" href="/admin">
          Administration
        </Link>
        <Link color="inherit" href="/globalSettings/cardSetting">
          Cardholder & Card Settings
        </Link>
        <Typography color="textPrimary">Custom Record Fields</Typography>
      </Breadcrumbs>
      <br></br>
      <div className={classes.content}>
        <Paper>
          <Grid
            container
            direction="row"
            justify="space-evenly"
            alignItems="stretch"
            className={classes.gridcontainer}
          >
            <Grid item xs={6} className={classes.grid}>
              <p>
                You can use this area to edit the fields that are used in the Cardholder Records.
                Display order can be changed by dragging items in the right pane up and down.
              </p>

              <br></br>
              <div className={classes.form}>
                <Grid container spacing={3}>
                  <Grid item xs={9}>
                    <FormControl
                      variant="outlined"
                      className={classes.textBoxcombo}
                      fullWidth={true}
                    >
                      <InputLabel>Field Type</InputLabel>
                      <Select
                        native
                        label="Field Type"
                        variant="outlined"
                        value={fieldType}
                        onChange={handleFieldType}
                      >
                        <option value="textField">Text Field</option>
                        <option value="numField">Numerical Field</option>
                        <option value="dateField">Date/Time Field</option>
                        <option value="custom">Custom Field</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={9}>
                    <FormControl
                      variant="outlined"
                      className={classes.textBoxcombo}
                      fullWidth={true}
                    >
                      <InputLabel shrink={true} style={{ backgroundColor: 'white' }}>
                        Sub Type
                      </InputLabel>
                      <Select
                        native
                        label="Sub Type"
                        defaultValue={fields[0]}
                        ref={subComponet}
                        value={subType}
                        onKeyPress={handleType}
                        onChange={handleType}
                      >
                        {!loading && !error && fieldType === 'textField'
                          ? (options = subOptions
                              .filter((field) => field.type.includes('string'))
                              .map(({ id, label }) => {
                                return (
                                  <option value={label} key={id}>
                                    {label}
                                  </option>
                                );
                              }))
                          : fieldType === 'numField'
                          ? (options = subOptions
                              .filter((field) => field.type.includes('integer'))
                              .map(({ id, label }) => <option value={label}>{label}</option>))
                          : fieldType === 'dateField'
                          ? (options = subOptions
                              .filter(
                                (field) =>
                                  field.type.includes('datetime') || field.type.includes('date')
                              )
                              .map(({ id, label }) => <option value={label}>{label}</option>))
                          : fieldType === 'custom'
                          ? (options = subOptions
                              .filter((field) => field.type.includes('mapping'))
                              .map((field) => {
                                return (
                                  <>
                                    <option value={field.label}>{field.label}</option>
                                  </>
                                );
                              }))
                          : (options = fields.map(({ id, label, type }) => (
                              <option value={label} key={id}>
                                {label}
                              </option>
                            )))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {fieldenabled ? (
                    <>
                      <Grid item xs={9}>
                        <FormControl
                          variant="outlined"
                          className={classes.textBoxcombo}
                          fullWidth={true}
                        >
                          <InputLabel shrink={true} style={{ backgroundColor: 'white' }}>
                            Custom Field
                          </InputLabel>
                          <Select
                            native
                            label="Custom Field"
                            ref={customComponent}
                            value={customField}
                            name={customField}
                            onChange={handleCustomField}
                          >
                            {!loading && !error && FieldsList
                              ? (fieldoptions = FieldsList.filter((field) =>
                                  field.id.includes(subType)
                                ).map(({ id, label }) => {
                                  return <option value={label}>{label}</option>;
                                }))
                              : () => {
                                  return <Typography>Error, No Data Loaded</Typography>;
                                }}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}></Grid>
                    </>
                  ) : (
                    <></>
                  )}
                  <Grid item xs={9} className={classes.textfield}>
                    <FormControl className={classes.textBoxcombo} fullWidth>
                      <TextField
                        variant="outlined"
                        disabled
                        value={fieldName}
                        onChange={(e) => setFieldName(e.target.value)}
                        id="standard-basic"
                        label="Field Name"
                        style={matches ? { width: 'max-content' } : {}}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={9} className={classes.textfield}>
                    <FormControl className={classes.textBoxcombo} fullWidth>
                      <TextField
                        variant="outlined"
                        disabled
                        value={defaultValue}
                        onChange={(e) => setDefaultValue(e.target.value)}
                        id="standard-basic"
                        label="Default Value"
                        style={matches ? { width: 'max-content' } : {}}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={9} className={classes.textfield}>
                    <FormControl
                      variant="outlined"
                      className={classes.textBoxcombo}
                      fullWidth
                      disabled
                    >
                      <InputLabel>Database Field</InputLabel>
                      <Select native label="Database Field">
                        <option value=""></option>
                        <option value="">Sample</option>
                        <option value="">Sample</option>
                        <option value="">Sample</option>
                        <option value="">Sample</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  <div className={classes.checkbox}>
                    <FormControlLabel
                      style={{ marginRight: '200px' }}
                      value=""
                      control={<Checkbox color="secondary" disabled />}
                      label="Required Field"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value=""
                      style={{ position: 'absolute', right: '58%' }}
                      control={<Checkbox color="secondary" disabled />}
                      label="Enable for access groups ? "
                      labelPlacement="end"
                    />
                  </div>
                  <div className={classes.checkbox}>
                    <Button
                      variant="contained"
                      style={{
                        height: '40px',
                        width: '100px',
                        left: '49%',
                        position: 'absolute',
                      }}
                      color="secondary"
                      onClick={handleAdd}
                    >
                      Add
                    </Button>
                  </div>
                  <Grid item sm={12} style={{ marginBottom: '-93px', marginTop: '100px' }}>
                    <div className={classes.buttonList}>
                      <Button
                        variant="contained"
                        style={{
                          height: '40px',
                          width: '200px',
                          marginLeft: '-100px',
                        }}
                        color="primary"
                        onClick={() => {
                          restoreDefault().then(() => {
                            handleUpdate();
                            sleep(1000).then(() => {
                              refetchRelist();
                            });
                          });
                        }}
                      >
                        Restore Default Order
                      </Button>
                      &emsp;
                      <div className={classes.buttonListtwo}>
                        <Button
                          variant="text"
                          style={{
                            height: '40px',
                            width: '100px',
                          }}
                          onClick={(e) => {
                            resetList();
                          }}
                        >
                          Cancel
                        </Button>
                        &emsp;
                        <Button
                          variant="contained"
                          style={{
                            height: '40px',
                            width: '100px',
                          }}
                          color="secondary"
                          onClick={() => {
                            handleSave().then(() => {
                              handleUpdate();
                            });
                          }}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  </Grid>
                </Grid>
                <br></br>
              </div>
            </Grid>
            <Divider
              orientation={width > 1325 ? 'vertical' : 'horizontal'}
              flexItem
              variant="fullWidth"
              style={
                width < 1325 ? { display: 'contents' } : width < 1471 ? { display: 'none' } : {}
              }
            />
            <div></div>

            <div className={classes.dragdrop}>
              {isFieldsUpdated && (
                <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="characters">
                    {(provided, snapshot) => (
                      <ul
                        className="characters"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {!loading &&
                          !error &&
                          fields.map((field, index) => {
                            if (field.type === 'mapping') {
                              return (
                                <Draggable
                                  key={field.label}
                                  draggableId={field.label}
                                  index={index}
                                  disableInteractiveElementBlocking
                                >
                                  {(provided, snapshot) => (
                                    <Container>
                                      <div>
                                        <div {...provided.draggableProps} ref={provided.innerRef}>
                                          <li>
                                            <div className="characters-thumb">
                                              <div {...provided.dragHandleProps}>
                                                <DragIndicatorIcon></DragIndicatorIcon>
                                              </div>
                                              <p style={{ margin: 'auto' }}>{field.label}</p>
                                              <div>
                                                {!loading && !error && !field.required && (
                                                  <DeleteIcon
                                                    className={classes.trashcan}
                                                    onClick={(e) => {
                                                      handleDeleteField(e, field);
                                                    }}
                                                  ></DeleteIcon>
                                                )}
                                              </div>
                                            </div>
                                          </li>
                                        </div>
                                      </div>
                                    </Container>
                                  )}
                                </Draggable>
                              );
                            } else {
                              return (
                                <Draggable
                                  key={field.id}
                                  draggableId={field.id}
                                  index={index}
                                  disableInteractiveElementBlocking
                                >
                                  {(provided, snapshot) => (
                                    <Container>
                                      <div>
                                        <div {...provided.draggableProps} ref={provided.innerRef}>
                                          <li>
                                            <div className="characters-thumb">
                                              <div {...provided.dragHandleProps}>
                                                <DragIndicatorIcon></DragIndicatorIcon>
                                              </div>
                                              <p style={{ margin: 'auto' }}>{field.label}</p>
                                              <div>
                                                {!loading && !error && !field.required && (
                                                  <DeleteIcon
                                                    className={classes.trashcan}
                                                    onClick={(e) => {
                                                      handleDeleteField(e, field);
                                                    }}
                                                  ></DeleteIcon>
                                                )}
                                              </div>
                                            </div>
                                          </li>
                                        </div>
                                      </div>
                                    </Container>
                                  )}
                                </Draggable>
                              );
                            }
                          })}
                        {provided.placeholder}
                      </ul>
                    )}
                  </Droppable>
                </DragDropContext>
              )}
            </div>
          </Grid>
          <br></br>
          <br></br>
          <br></br>
        </Paper>
        <Snackbar open={openSnack} autoHideDuration={3000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success">
            Fields Saved Successfully!
          </Alert>
        </Snackbar>
        <Snackbar open={defaultOpen} autoHideDuration={2000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success">
            Default Fields Restored!
          </Alert>
        </Snackbar>
      </div>
    </>
  );
};

export default CardholderFields;
